/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { NgModule } from '@angular/core';
import { DATA_SERVICES } from './services';
import * as i0 from "@angular/core";
var SupplierSharedDataModule = /** @class */ (function () {
    function SupplierSharedDataModule() {
    }
    SupplierSharedDataModule.forRoot = function () {
        return {
            ngModule: SupplierSharedDataModule,
            providers: DATA_SERVICES,
        };
    };
    SupplierSharedDataModule.forChild = function () {
        return {
            ngModule: SupplierSharedDataModule,
            providers: [],
        };
    };
    SupplierSharedDataModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierSharedDataModule });
    SupplierSharedDataModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierSharedDataModule_Factory(t) { return new (t || SupplierSharedDataModule)(); }, imports: [[]] });
    return SupplierSharedDataModule;
}());
export { SupplierSharedDataModule };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierSharedDataModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
            }]
    }], null, null); })();
